import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.303 1c.306 0 .554.242.554.541V22.46a.548.548 0 0 1-.554.541.548.548 0 0 1-.554-.541V1.54c0-.299.248-.541.554-.541ZM2.238 8.283a.554.554 0 0 1 .782-.05 5.165 5.165 0 0 1 1.76 3.888 5.168 5.168 0 0 1-1.76 3.89.554.554 0 1 1-.732-.833 4.057 4.057 0 0 0 1.385-3.057c0-1.218-.535-2.31-1.385-3.056a.554.554 0 0 1-.05-.782Zm2.681-1.784a.554.554 0 0 0-.73.833 6.36 6.36 0 0 1 .193 9.407.554.554 0 0 0 .765.801A7.468 7.468 0 0 0 4.919 6.5ZM6.17 4.25a.554.554 0 0 1 .784.015 11.291 11.291 0 0 1 3.173 7.855c0 2.633-.903 5.056-2.41 6.978a.554.554 0 1 1-.872-.684 10.158 10.158 0 0 0 2.175-6.293c0-2.753-1.092-5.248-2.864-7.088a.554.554 0 0 1 .015-.783Zm8.956 8.499a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Zm3.125-.625a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0Zm1.875.625a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.238 8.283a.554.554 0 0 1 .782-.05 5.165 5.165 0 0 1 1.76 3.888 5.168 5.168 0 0 1-1.76 3.89.554.554 0 1 1-.732-.833 4.057 4.057 0 0 0 1.385-3.057c0-1.218-.535-2.31-1.385-3.056a.554.554 0 0 1-.05-.782Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.138 6.55a.554.554 0 0 1 .781-.051 7.468 7.468 0 0 1 .227 11.041.554.554 0 1 1-.764-.801 6.36 6.36 0 0 0-.193-9.407.554.554 0 0 1-.051-.782Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.17 4.25a.554.554 0 0 1 .783.016 11.292 11.292 0 0 1 3.173 7.855c0 2.633-.903 5.056-2.41 6.978a.554.554 0 1 1-.872-.684 10.158 10.158 0 0 0 2.174-6.293c0-2.753-1.091-5.248-2.863-7.088a.554.554 0 0 1 .015-.783ZM2.238 8.283a.554.554 0 0 1 .782-.05 5.165 5.165 0 0 1 1.76 3.888 5.168 5.168 0 0 1-1.76 3.89.554.554 0 1 1-.732-.833 4.057 4.057 0 0 0 1.385-3.057c0-1.218-.535-2.31-1.385-3.056a.554.554 0 0 1-.05-.782Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.138 6.55a.554.554 0 0 1 .781-.051 7.468 7.468 0 0 1 .227 11.041.554.554 0 1 1-.764-.801 6.36 6.36 0 0 0-.193-9.407.554.554 0 0 1-.051-.782Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.17 4.25a.554.554 0 0 1 .783.016 11.292 11.292 0 0 1 3.173 7.855c0 2.633-.903 5.056-2.41 6.978a.554.554 0 1 1-.872-.684 10.158 10.158 0 0 0 2.174-6.293c0-2.753-1.091-5.248-2.863-7.088a.554.554 0 0 1 .015-.783Z",
      clipRule: "evenodd"
    }
  )
);
var SvgNoiseCancellationOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var NoiseCancellationOutlined_default = SvgNoiseCancellationOutlined;

export { NoiseCancellationOutlined_default as default };
